module.exports = __webpack_public_path__ + "img/uploadPictures.9b2b799e.png";